import React, { useEffect, useState } from 'react';
import './Organizations.css';
import api from '../utils/api';

function Organizations() {
 const [organizations, setOrganizations] = useState([]);
 const [selectedOrg, setSelectedOrg] = useState(null);
 const [orgUsers, setOrgUsers] = useState([]);
 const [sports, setSports] = useState([]);
 const [isCreateUserModalOpen, setIsCreateUserModalOpen] = useState(false);
 const [isEditUserModalOpen, setIsEditUserModalOpen] = useState(false);
 const [userForm, setUserForm] = useState({ username: '', email: '', password: '', role: 'staff', resetPassword: false});
 const [editingUser, setEditingUser] = useState(null);
 const [loading, setLoading] = useState(false);
 const [orgForm, setOrgForm] = useState({ name: '', domain: '', slug: '', customPageUrl: '', customSite: false });
 const [editingOrg, setEditingOrg] = useState(null);
 const [isCreateOrgModalOpen, setIsCreateOrgModalOpen] = useState(false);
 const [isEditOrgModalOpen, setIsEditOrgModalOpen] = useState(false);
 const [allUsers, setAllUsers] = useState([])
 const roles = [
  { value: 'org_owner', label: 'Organization Owner' },
  { value: 'staff', label: 'Staff' }
 ];


 const fetchAllUsers = async () => {
  try {
   const response = await api.get('/api/usersv2', { withCredentials: true });
   setAllUsers(response.data.users || []);
  } catch (error) {
   console.error('Error fetching users', error);
  }
 };

 const fetchOrganizations = async () => {
  try {
   const response = await api.get('/api/organizations', { withCredentials: true });
   setOrganizations(response.data.organizations || []);
  } catch (error) {
   console.error('Error fetching organizations');
  }
 };

 const fetchSports = async () => {
  try {
   const response = await api.get('/api/sportsv2', { withCredentials: true });
   setSports(response.data.sports || []);
  } catch (error) {
   console.error('Error fetching sports');
  }
 };

 useEffect(() => {
  fetchOrganizations();
  fetchSports();
  fetchAllUsers();
 }, []);





 const handleLoadUsers = async (organizationId) => {
  setSelectedOrg(organizationId);
  setLoading(true);
  try {
   const response = await api.get(`/api/organizations/${organizationId}`, { withCredentials: true });
   setOrgUsers(response.data.organization.users || []);
  } catch (error) {
   console.error('Error fetching users for organization');
  } finally {
   setLoading(false);
  }
 };

 const openCreateUserModal = () => {
  setUserForm({ username: '', email: '', password: '', role: 'staff'});
  setIsCreateUserModalOpen(true);
 };


 const openCreateOrgModal = () => {
  setOrgForm({
   name: '',
   domain: '',
   slug: '',
   sportIds: [],
   logo: null,
   facebook_url: '',
   instagram_url: '',
   youtube_url: ''
  });

  setEditingOrg(null);
  setIsCreateOrgModalOpen(true);
 };

 const openEditOrgModal = (org) => {
  setEditingOrg(org);
  setOrgForm({
   name: org.name,
   domain: org.domain || '',
   slug: org.slug || '',
   sportIds: org.sports ? org.sports.map(s => s.id) : [],
   facebook_url: org.facebook_url || '',
   instagram_url: org.instagram_url || '',
   youtube_url: org.youtube_url || ''

  });
  setIsEditOrgModalOpen(true);
 };


 const openEditUserModal = (user) => {
  setEditingUser(user);
  setUserForm({
   username: user.username,
   email: user.email || '',
   role: user.role || '',
   resetPassword: false,
  });
  setIsEditUserModalOpen(true);
 };



 const handleCreateOrganization = async (e) => {
  e.preventDefault();
  try {
   const formData = new FormData();
   for (const key in orgForm) {
    if (key === 'sportIds') {
     orgForm.sportIds.forEach(id => formData.append('sportIds[]', id));
    } else if (key === 'logo' && orgForm.logo) {
     formData.append('logo', orgForm.logo); // ✅ Append actual file
    } else {
     formData.append(key, orgForm[key]);
    }
   }


   await api.post('/api/organizations', formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
   });

   await fetchOrganizations();
   setSelectedOrg(null);  // 🛠 Clear selected
   setIsCreateOrgModalOpen(false);
  } catch (error) {
   console.error('Error creating organization:', error);
   alert(error.response?.data?.message || 'Error creating organization');
  }
 };

 const handleCreateUser = async (e) => {
  e.preventDefault();
  try {
   if (userForm.existingUserId) {
    // ✅ If existing user selected, just attach to org
    await api.post(`/api/organizations/${selectedOrg}/addUser`, {
     userId: userForm.existingUserId,
    }, { withCredentials: true });
   } else {
    // ✅ Otherwise, create new user
    const body = {
     ...userForm,
     organization_id: selectedOrg,
     sportIds: userForm.sportIds?.map(id => Number(id)) || [],
    };
    await api.post('/api/usersv2', body, { withCredentials: true });
   }
   await handleLoadUsers(selectedOrg);
   setIsCreateUserModalOpen(false);
  } catch (error) {
   console.error('Error creating or adding user', error);
   alert(error.response?.data?.message || 'Error creating or adding user');
  }
 };


 const handleUpdateOrganization = async (e) => {
  e.preventDefault();
  try {
   const formData = new FormData();
   for (const key in orgForm) {
    if (key === 'sportIds') {
     orgForm.sportIds.forEach(id => formData.append('sportIds[]', id));
    } else {
     formData.append(key, orgForm[key]);
    }
   }

   await api.put(`/api/organizations/${editingOrg.id}`, formData, {
    withCredentials: true,
    headers: { 'Content-Type': 'multipart/form-data' },
   });

   await fetchOrganizations();
   setSelectedOrg(null); // 🛠 Clear selected
   setIsEditOrgModalOpen(false);
  } catch (error) {
   console.error('Error updating organization:', error);
   alert(error.response?.data?.message || 'Error updating organization');
  }
 };



 const handleUpdateUser = async (e) => {
  e.preventDefault();
  try {
   const body = {
    username: userForm.username,
    email: userForm.email.trim(),
    role: userForm.role,
    resetPassword: userForm.resetPassword,
    sportIds: userForm.sportIds || [],
   };

   const response = await api.put(`/api/usersv2/${editingUser.id}`, body, { withCredentials: true });

   if (response.data.tempPassword) {
    alert(`Temporary Password: ${response.data.tempPassword}`);
   }

   await handleLoadUsers(selectedOrg);
   setIsEditUserModalOpen(false);
  } catch (error) {
   console.error('Error updating user', error);
   alert(error.response?.data?.message || 'Error updating user');
  }
 };



 const handleDeleteUser = async (userId) => {
  const confirmDelete = window.confirm('Are you sure you want to delete this user?');
  if (!confirmDelete) return;
  try {
   await api.delete(`/api/usersv2/${userId}`, { withCredentials: true });
   setOrgUsers(prev => prev.filter(u => u.id !== userId));
  } catch (error) {
   console.error('Error deleting user');
   alert(error.response?.data?.message || 'Error deleting user');
  }
 };

 const handleInputChange = (e) => {
  const { name, value } = e.target;
  setUserForm(prev => ({ ...prev, [name]: value }));
 };

 const handleDeleteOrganization = async (orgId) => {
  const confirmDelete = window.confirm('Are you sure you want to delete this organization?');
  if (!confirmDelete) return;
  try {
   await api.delete(`/api/organizations/${orgId}`, { withCredentials: true });
   await fetchOrganizations();
   setSelectedOrg(null); // 🛠 Clear selected
  } catch (error) {
   console.error('Error deleting organization');
   alert(error.response?.data?.message || 'Error deleting organization');
  }
 };

 const handleOrgInputChange = (e) => {
  const { name, value } = e.target;
  setOrgForm(prev => ({ ...prev, [name]: value }));
 };



 console.log(organizations)
 return (
  <div className="organizations-container">
   <h2>Organizations</h2>
   <button className="add-organization-btn" onClick={openCreateOrgModal}>
    + Add Organization
   </button>




   {isCreateOrgModalOpen && (
    <div className="modal">
     <div className="modal-content">
      <h3>Create Organization</h3>
      <form onSubmit={handleCreateOrganization}>
       <input type="text" name="name" value={orgForm.name} onChange={handleOrgInputChange} placeholder="Organization Name" required />
       <input type="text" name="domain" value={orgForm.domain} onChange={handleOrgInputChange} placeholder="Domain" />
       <input type="text" name="slug" value={orgForm.slug} onChange={handleOrgInputChange} placeholder="Slug" />
       <input
        type="text"
        name="facebook_url"
        value={orgForm.facebook_url || ''}
        onChange={handleOrgInputChange}
        placeholder="Facebook URL"
       />

       <input
        type="text"
        name="instagram_url"
        value={orgForm.instagram_url || ''}
        onChange={handleOrgInputChange}
        placeholder="Instagram URL"
       />

       <input
        type="text"
        name="youtube_url"
        value={orgForm.youtube_url || ''}
        onChange={handleOrgInputChange}
        placeholder="YouTube URL"
       />

       <label>Select Sports:</label>
       <select
        multiple
        name="sportIds"
        value={orgForm.sportIds || []}
        onChange={(e) => {
         const selected = Array.from(e.target.selectedOptions).map(opt => opt.value);
         setOrgForm(prev => ({ ...prev, sportIds: selected }));
        }}
       >
        {sports.map((sport) => (
         <option key={sport.id} value={sport.id}>
          {sport.name || sport.type}
         </option>
        ))}
       </select>
       <input
        type="file"
        name="logo"
        accept="image/*"
        onChange={(e) => setOrgForm(prev => ({ ...prev, logo: e.target.files[0] }))}
       />

       <input
        type="text"
        name="customPageUrl"
        value={orgForm.customPageUrl}
        onChange={handleOrgInputChange}
        placeholder="Custom Page URL (optional)"
       />

       <label>
        <input
         type="checkbox"
         name="customSite"
         checked={orgForm.customSite}
         onChange={(e) => setOrgForm(prev => ({ ...prev, customSite: e.target.checked }))}
        />
        Use Custom Site
       </label>
       <button type="submit">Create</button>
       <button type="button" onClick={() => setIsCreateOrgModalOpen(false)}>Cancel</button>
      </form>
     </div>
    </div>
   )}
   {isEditOrgModalOpen && (
    <div className="modal">
     <div className="modal-content">
      <h3>Edit Organization</h3>
      <form onSubmit={handleUpdateOrganization}>
       <input type="text" name="name" value={orgForm.name} onChange={handleOrgInputChange} placeholder="Organization Name" required />
       <input type="text" name="domain" value={orgForm.domain} onChange={handleOrgInputChange} placeholder="Domain" />
       <input type="text" name="slug" value={orgForm.slug} onChange={handleOrgInputChange} placeholder="Slug" />
       <input
        type="text"
        name="facebook_url"
        value={orgForm.facebook_url || ''}
        onChange={handleOrgInputChange}
        placeholder="Facebook URL"
       />

       <input
        type="text"
        name="instagram_url"
        value={orgForm.instagram_url || ''}
        onChange={handleOrgInputChange}
        placeholder="Instagram URL"
       />

       <input
        type="text"
        name="youtube_url"
        value={orgForm.youtube_url || ''}
        onChange={handleOrgInputChange}
        placeholder="YouTube URL"
       />

       <label>Select Sports:</label>
       <select
        multiple
        name="sportIds"
        value={orgForm.sportIds || []}
        onChange={(e) => {
         const selected = Array.from(e.target.selectedOptions).map(opt => opt.value);
         setOrgForm(prev => ({ ...prev, sportIds: selected }));
        }}
       >
        {sports.map((sport) => (
         <option key={sport.id} value={sport.id}>
          {sport.name || sport.type}
         </option>
        ))}
       </select>
       <input
        type="file"
        name="logo"
        accept="image/*"
        onChange={(e) => setOrgForm(prev => ({ ...prev, logo: e.target.files[0] }))}
       />

       {/* <input
        type="text"
        name="customPageUrl"
        value={orgForm.customPageUrl}
        onChange={handleOrgInputChange}
        placeholder="Custom Page URL (optional)"
       /> */}

       <label>
        <input
         type="checkbox"
         name="customSite"
         checked={orgForm.customSite}
         onChange={(e) => setOrgForm(prev => ({ ...prev, customSite: e.target.checked }))}
        />
        Use Custom Site
       </label>
       <button type="submit">Update</button>
       <button type="button" onClick={() => setIsEditOrgModalOpen(false)}>Cancel</button>
      </form>
     </div>
    </div>
   )}


   {organizations.map((org) => (
    <div key={org.id} className="organization-card">
     <div className="organization-header" onClick={() => handleLoadUsers(org.id)}>
      <strong>{org.name}</strong> ({org.domain || 'No domain'}) 
      {org.sports && org.sports.length > 0 && (
       <div className="organization-sports">
        {org.sports.map((sport) => (
         <h4 key={sport.id}>{sport.type}</h4>  
        ))}
       </div>
      )}
      <div className="organization-actions">
       <button onClick={(e) => { e.stopPropagation(); openEditOrgModal(org); }}>✏️</button>
       <button onClick={(e) => { e.stopPropagation(); handleDeleteOrganization(org.id); }}>🗑️</button>
      </div>
     </div>

     {/* 👇 MOVE this inside here */}
     {selectedOrg === org.id && (
      <div className="organization-users">
       <button className="add-user-btn" onClick={openCreateUserModal}>+ Add User</button>
       {loading ? (
        <p>Loading users...</p>
       ) : (
        <>
         {orgUsers.length > 0 ? (
          orgUsers.map((user) => (
           <div key={user.id} className="user-item">
            {user.username} ({user.email}) - {user.role}
            <button onClick={() => openEditUserModal(user)}>✏️</button>
            <button onClick={() => handleDeleteUser(user.id)}>🗑️</button>
           </div>
          ))
         ) : (
          <p>No users found.</p>
         )}
        </>
       )}
      </div>
     )}
    </div>
   ))}


   {/* Create User Modal */}
   {isCreateUserModalOpen && (
    <div className="modal">
     <div className="modal-content">
      <h3>Create User</h3>
      <form onSubmit={handleCreateUser}>
       <input type="text" name="username" value={userForm.username} onChange={handleInputChange} placeholder="Username" required />
       <input type="email" name="email" value={userForm.email} onChange={handleInputChange} placeholder="Email" />
       <input type="password" name="password" value={userForm.password} onChange={handleInputChange} placeholder="Password" />
       <select
        value={userForm.role}
        onChange={(e) => setUserForm({ ...userForm, role: e.target.value })}
       >
        {roles.map((role) => (
         <option key={role.value} value={role.value}>
          {role.label}
         </option>
        ))}
        <input
         type="file"
         name="logo"
         accept="image/*"
         onChange={(e) => setOrgForm(prev => ({ ...prev, logo: e.target.files[0] }))}
        />

       </select>
       <label>Choose Existing User (optional):</label>
       <select
        value={userForm.existingUserId || ''}
        onChange={(e) => {
         const selectedUserId = e.target.value;
         setUserForm(prev => ({ ...prev, existingUserId: selectedUserId }));
        }}
       >
        <option value="">-- Create New User --</option>
        {allUsers.map((user) => (
         <option key={user.id} value={user.id}>
          {user.username} ({user.email})
         </option>
        ))}
       </select>

       <button type="submit">Create</button>
       <button type="button" onClick={() => setIsCreateUserModalOpen(false)}>Cancel</button>
      </form>
     </div>
    </div>
   )}

   {/* Edit User Modal */}
   {isEditUserModalOpen && (
    <div className="modal">
     <div className="modal-content">
      <h3>Edit User</h3>
      <form onSubmit={handleUpdateUser}>
       <input type="text" name="username" value={userForm.username} onChange={handleInputChange} placeholder="Username" required />
       <input type="email" name="email" value={userForm.email} onChange={handleInputChange} placeholder="Email" />
       <select
        value={userForm.role}
        onChange={(e) => setUserForm({ ...userForm, role: e.target.value })}
       >
        {roles.map((role) => (
         <option key={role.value} value={role.value}>
          {role.label}
         </option>
        ))}
       </select>
       <label>
        <input
         type="checkbox"
         name="resetPassword"
         checked={userForm.resetPassword || false}
         onChange={(e) => setUserForm(prev => ({ ...prev, resetPassword: e.target.checked }))}
        />
        Reset Password (Generate Temp Password)
       </label>
       <button type="submit">Update</button>
       <button type="button" onClick={() => setIsEditUserModalOpen(false)}>Cancel</button>
      </form>
     </div>
    </div>
   )}
  </div>
 );
}

export default Organizations;
